import { render, staticRenderFns } from "./SelectTravelType.vue?vue&type=template&id=04894d5f&scoped=true"
import script from "./SelectTravelType.vue?vue&type=script&lang=ts"
export * from "./SelectTravelType.vue?vue&type=script&lang=ts"
import style0 from "./SelectTravelType.vue?vue&type=style&index=0&id=04894d5f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04894d5f",
  null
  
)

export default component.exports